import { doRequest, Methods } from 'Request';

export const postQuotesSubmitOpportunity = async (quoteId: string) => {
  return doRequest({
    method: Methods.POST,
    path: `/quotes/${quoteId}/submit-opportunity`,
  });
};
